const paymentItems     = document.querySelectorAll('.payment-amount-item');
const inputAmount      = document.querySelector('#input-amount')
const totalAmountPay   = document.querySelector('#total-amount-pay')
const eventListener    = ['keypress', 'keyup', 'change']

function handlePaymentItemSelection(event) {
  const selectedRadio = event.target;
  
  if (selectedRadio.checked) {
    paymentItems.forEach(item => {
      item.classList.remove('active');
    });
    
    const selectedPaymentItem = selectedRadio.closest('.payment-amount-item');
    if (selectedPaymentItem) {
      selectedPaymentItem.classList.add('active');
    }

    if (inputAmount) {
      inputAmount.value = selectedRadio.dataset.amount
    }

    updateTotalAmountPay(selectedRadio.dataset.amount)
  }
}

function updateTotalAmountPay(amount) {
  const currency = totalAmountPay.dataset['currency']

  if (totalAmountPay) {
    totalAmountPay.textContent = `${currency}${formatMoney(amount)}`
  }
}

function updateLabelPaymentItem(element) {
  paymentItems.forEach(item => {
    var amount = item.querySelector('.input-amount').dataset['amount']
    item.classList.remove('active')

    if (element.value == amount) {
      item.classList.add('active')
    }
  })
}

paymentItems.forEach(item => {
  const radio  = item.querySelector('.form-check-input');
  if (radio) {
    radio.addEventListener('change', handlePaymentItemSelection);
  }
});

if (inputAmount) {
  eventListener.forEach(e => {
    inputAmount.addEventListener(e, function(event) {
      updateLabelPaymentItem(event.target)
      setTimeout(function () {
        updateTotalAmountPay(event.target.value)
      }, 50)
    })
  })
}